import { useEffect, useState } from "react";
import { GetInviteLinkRequest, InvitationLinksResponse, SignalRResponse } from "../Data/ScapeData";


interface InvitationLinkViewArgs {
    scapeConnection?: signalR.HubConnection;
    scapeId: string;
    gameId?: string;
}

const InvitationLinkView: React.FC<InvitationLinkViewArgs> = args => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    var [scapeLink, setScapeLink] = useState<string>(null);
    var [gameLink, setGameLink] = useState<string>(null);
    var [errorMessage, setErrorMessage] = useState<string>(null);


    useEffect(() => {
        if (!args.scapeConnection) {
            return;
        }
        console.log("Starting to get invitation links");
        const req: GetInviteLinkRequest = {
            Id: args.scapeId,
            GameId: args.gameId
        };
        args.scapeConnection.invoke('GetInviteLink', req)
            .then((result: SignalRResponse<InvitationLinksResponse>) => {
                console.log(result);
                setScapeLink(result.data.scapeInvitationUrl);
                setGameLink(result.data.gameInvitationUrl);
            }).catch((e: Error) => {
                console.log("error");
                console.log(e);
                setErrorMessage(e.message);
            }).finally(() => {
                setIsLoading(false);
            });
    }, [args.scapeConnection]);

    if (isLoading) {
        return <p>Loading Invitation Links</p>
    }
    if (errorMessage) {
        return <p>There was an error {errorMessage}</p>
    }
    if (!scapeLink) {
        return <p>Unknown error: missing Scape.</p>
    }

    return <ul>
        <li>Scape Link: {scapeLink}</li>
        <li>Game Link: {gameLink}</li>
    </ul>
}

export default InvitationLinkView;